var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotography(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.309 4.781a.328.328 0 00-.329.328v13.782c0 .18.147.328.329.328h1.234a.888.888 0 01.038-.04l7.977-7.977a2.297 2.297 0 013.165-.079l4.32 3.909V5.109a.328.328 0 00-.328-.328H4.309zM20.715 19.22H8.325l6.625-6.625a.328.328 0 01.452-.01l5.641 5.103v1.204a.328.328 0 01-.328.328zm2.297-.328V5.109a2.297 2.297 0 00-2.297-2.296H4.309a2.297 2.297 0 00-2.297 2.296v13.782a2.297 2.297 0 002.297 2.297h16.406a2.297 2.297 0 002.297-2.297zM9.23 9.375a.656.656 0 11-1.312 0 .656.656 0 011.312 0zm1.97 0a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "media/small/photography-3170ba67.svg";
export { SvgPhotography as ReactComponent };